import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckIcon } from '../../icons';
import './SuccessStep.scss';
export const SuccessStep = ({ isWaitingForConfirmation }) => {
    const { t } = useTranslation();
    const handleButtonClick = () => {
        window.location.replace(window.avAppConfig.registrationUrl);
    };
    return (React.createElement("div", { className: "success-step" },
        React.createElement(CheckIcon, { width: 64, height: 64 }),
        React.createElement("h2", { className: "success-step__title" }, t('success-step.title')),
        isWaitingForConfirmation ? (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "success-step__description" }, t('partial-success-step.description')),
            React.createElement("p", { className: "success-step__description" }, t('partial-success-step.note')),
            React.createElement("p", { className: "success-step__description" }, t('partial-success-step.subDescription')))) : (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "success-step__description" }, t('success-step.description')),
            React.createElement("p", { className: "success-step__description" }, t('success-step.subDescription')))),
        React.createElement("button", { className: "success-step__button", onClick: handleButtonClick }, isWaitingForConfirmation ? t('partial-success-step.close') : t('success-step.login'))));
};
//# sourceMappingURL=SuccessStep.js.map